import { Component } from '@angular/core';

import { MessengerEmailComponent } from '../messages/messenger/messenger.email.component';

@Component({
  selector   : 'inspection-email',
  template: require('./inspection.email.component.html')
})
export class InspectionEmailComponent extends MessengerEmailComponent {}
